"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRow = exports.DefaultInput = exports.def = exports.getFormInputs = void 0;
const react_1 = __importDefault(require("react"));
const FormTypes_1 = require("./FormTypes");
const TagSelector_1 = require("../other/TagSelector/TagSelector");
const UserSelector_1 = __importDefault(require("../other/UserSelector/UserSelector"));
const CheckBox_1 = __importDefault(require("./inputs/CheckBox"));
const IconSel_1 = __importDefault(require("./inputs/IconSel"));
const IconTextSel_1 = __importDefault(require("./inputs/IconTextSel"));
const ContentSwitcher_1 = __importDefault(require("../controlls/ContentSwitch/ContentSwitcher"));
const util_1 = require("../../util");
/**
 * Get FormInputList
 * @param options
 */
function getFormInputs(options) {
    const out = [];
    options.forEach((option) => {
        option.forEach((el) => {
            if (Array.isArray(el)) {
                out.push(...el);
            }
            else if (el) {
                out.push(el);
            }
        });
    });
    return out;
}
exports.getFormInputs = getFormInputs;
/**
 * Define Default value for empty field
 * @param options
 */
function def(options) {
    const dd = {};
    getFormInputs(options).forEach((sel) => {
        const { key, type, value } = sel;
        switch (type) {
            case FormTypes_1.InputOptionType.TAG_SELECTOR:
                dd[key] = value || [];
                break;
            case FormTypes_1.InputOptionType.CUSTOM:
                dd[key] = value || sel.customElement?.init || null;
                break;
            case FormTypes_1.InputOptionType.TEXT:
            case FormTypes_1.InputOptionType.TEXT_FIELD:
            case FormTypes_1.InputOptionType.PASSWORD:
            case FormTypes_1.InputOptionType.COLOR:
            case FormTypes_1.InputOptionType.TIME:
            case FormTypes_1.InputOptionType.DATE:
            case FormTypes_1.InputOptionType.DATE_TIME:
            case FormTypes_1.InputOptionType.USER_SELECTOR:
                dd[key] = value || '';
                break;
            case FormTypes_1.InputOptionType.NUMBER:
            case FormTypes_1.InputOptionType.RANGE:
            case FormTypes_1.InputOptionType.CONTENT_SWITCH:
                dd[key] = value || 0;
                break;
            case FormTypes_1.InputOptionType.DROPDOWN:
                dd[key] = sel.items?.[0]?.key || '';
                break;
            case FormTypes_1.InputOptionType.CHECKBOX:
                dd[key] = value || false;
                break;
            default:
                break;
        }
    });
    return dd;
}
exports.def = def;
const DefaultInput = ({ inp, e, numeric, form, updateForm, enterHandler, }) => {
    const { key, submitOnEnter, restriction, placeholder, disabled, autoFocus, readOnly, autoComplete, onChange, required, } = inp;
    return (react_1.default.createElement("input", { type: e, required: required, onKeyUp: submitOnEnter ? enterHandler : undefined, value: form[key], min: restriction?.min, max: restriction?.max, autoFocus: autoFocus, placeholder: placeholder, readOnly: readOnly, pattern: restriction?.pattern, disabled: disabled, autoComplete: autoComplete ? 'on' : 'off', onChange: (event) => {
            if (numeric) {
                onChange?.(parseFloat(event.target.value));
                updateForm(key, parseFloat(event.target.value));
            }
            else {
                onChange?.(event.target.value);
                updateForm(key, event.target.value);
            }
        } }));
};
exports.DefaultInput = DefaultInput;
exports.DefaultInput.defaultProps = {
    numeric: false,
};
/**
 * Define how to render the Element Row
 */
function FormRow({ option, form, updateForm, submitForm, error, }) {
    const enterHandler = (e) => {
        if (e.key === 'Enter' || e.code === 'Enter') {
            submitForm();
        }
        return null;
    };
    return (react_1.default.createElement("div", { key: option.reduce((acc, cur) => {
            return acc + cur && Array.isArray(cur)
                ? cur.reduce((a, c) => {
                    return a + c.key;
                }, '')
                : cur?.key || '';
        }, ''), className: "glx-form--row" }, option.map((opt) => {
        if (!opt) {
            return null;
        }
        let doList;
        if (Array.isArray(opt)) {
            doList = opt;
        }
        else {
            doList = [opt];
        }
        const input = doList.map((cur) => {
            const { type, key, label, hint, items, required, submitOnEnter, preload, onChange, disabled, autoFocus, accept, restriction, org, placeholder, } = cur;
            let iType;
            let noUnderline = false;
            /**
             * Define controlled input
             * Important:
             * set the current value prop to `form[key]` - bind the field to the tab data
             * bind the change function to the tab data - calling  `updateForm(key, $inputVal)`;
             */
            switch (type) {
                case FormTypes_1.InputOptionType.DROPDOWN:
                    iType = (react_1.default.createElement("select", { key: key, className: "glx-input-dark glx-w-full glx-m-2", value: form[key], autoFocus: autoFocus, required: required, placeholder: placeholder, disabled: disabled, onChange: (ev) => {
                            onChange?.(ev.target.value);
                            updateForm(key, ev.target.value);
                        } }, items?.map((el) => (react_1.default.createElement("option", { key: el.key, value: el.key }, el.name)))));
                    noUnderline = true;
                    break;
                case FormTypes_1.InputOptionType.CUSTOM:
                    iType = cur.customElement?.render(key, form, updateForm, items);
                    break;
                case FormTypes_1.InputOptionType.TEXT:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "text", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    break;
                case FormTypes_1.InputOptionType.RANGE:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "range", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    break;
                case FormTypes_1.InputOptionType.COLOR:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "color", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    noUnderline = true;
                    break;
                case FormTypes_1.InputOptionType.DATE:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "date", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    break;
                case FormTypes_1.InputOptionType.TIME:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "time", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    break;
                case FormTypes_1.InputOptionType.DATE_TIME:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "datetime-local", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    break;
                case FormTypes_1.InputOptionType.NUMBER:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "number", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler, numeric: true }));
                    break;
                case FormTypes_1.InputOptionType.PASSWORD:
                    iType = (react_1.default.createElement(exports.DefaultInput, { e: "password", form: form, inp: cur, updateForm: updateForm, enterHandler: enterHandler }));
                    break;
                case FormTypes_1.InputOptionType.FILE:
                    iType = (react_1.default.createElement("input", { key: key, type: "file", required: required, onKeyUp: submitOnEnter ? enterHandler : undefined, placeholder: placeholder, accept: accept, autoFocus: autoFocus, disabled: disabled, onChange: (event) => {
                            onChange?.(event.target.files?.[0] || null, event.target.value);
                            updateForm(key, event.target.value);
                        } }));
                    noUnderline = true;
                    break;
                case FormTypes_1.InputOptionType.ICON_TEXT:
                    iType = (react_1.default.createElement(IconTextSel_1.default, { key: key, onChange: (d) => {
                            onChange?.(d);
                            updateForm(key, d);
                        }, disabled: disabled, placeholder: placeholder, sel: form[key] }));
                    break;
                case FormTypes_1.InputOptionType.CHECKBOX:
                    iType = (react_1.default.createElement("div", null,
                        react_1.default.createElement(CheckBox_1.default, { key: key, disabled: disabled, checked: form[key], large: true, onChange: () => {
                                onChange?.(!form[key]);
                                updateForm(key, !form[key]);
                            } })));
                    break;
                case FormTypes_1.InputOptionType.ICON:
                    iType = (react_1.default.createElement("div", null,
                        react_1.default.createElement(IconSel_1.default, { key: key, disabled: disabled, sel: form[key], onChange: (x) => {
                                onChange?.(x);
                                updateForm(key, x);
                            } })));
                    break;
                case FormTypes_1.InputOptionType.CONTENT_SWITCH:
                    iType = (react_1.default.createElement("div", { key: key },
                        react_1.default.createElement(ContentSwitcher_1.default, { selectedIndex: form[key] ?? 0, onChange: (x) => {
                                onChange?.(x);
                                updateForm(key, x);
                            }, items: items ?? [] })));
                    noUnderline = true;
                    break;
                case FormTypes_1.InputOptionType.TAG_SELECTOR:
                    iType = (react_1.default.createElement(TagSelector_1.TagSelector, { key: key, placeholder: placeholder, disabled: disabled, value: form[key], autoFocus: autoFocus, items: items?.map((e) => ({
                            key: e.key,
                            text: e.name,
                            icon: e.icon || 'IOPricetagOutline',
                            color: e.other,
                        })), onChange: (els, dif) => {
                            onChange?.(els, dif);
                            updateForm(key, els);
                        } }));
                    break;
                case FormTypes_1.InputOptionType.USER_SELECTOR:
                    iType = (react_1.default.createElement(UserSelector_1.default, { key: key, placeholder: placeholder, disabled: disabled, value: form[key], onChange: (els) => {
                            onChange?.(els);
                            updateForm(key, els);
                        }, searchFC: preload, list: items && items.length > 0
                            ? items.map((e) => e.other)
                            : undefined }));
                    break;
                case FormTypes_1.InputOptionType.TEXT_FIELD:
                    iType = (react_1.default.createElement("textarea", { key: key, placeholder: placeholder, required: required, disabled: disabled, value: form[key], autoFocus: autoFocus, onChange: (event) => {
                            onChange?.(event.target.value);
                            updateForm(key, event.target.value);
                        }, rows: restriction?.rows ?? 5 }));
                    break;
                default:
                    return null;
            }
            return { iType, key, label, required, noUnderline };
        });
        return (react_1.default.createElement("div", { key: `container-${doList[0]?.key}`, className: `glx-form--input glx-form--sub-row glx-form--input--split-${option.length}` }, input.map((value) => (react_1.default.createElement("div", { key: `sub-container-${value?.key}`, className: (0, util_1.cnx)(`glx-form--input glx-form--input--split-${input.length}`, [!value?.noUnderline, 'glx-form--underline']) },
            value?.label ? (react_1.default.createElement("div", { className: "glx-form--label" },
                value.label,
                ' ',
                value.required ? (react_1.default.createElement("span", { className: "glx-form--error-text" }, "*")) : null)) : null,
            value?.iType,
            (() => {
                const fieldErr = error?.field?.find((e) => e.key === value?.key);
                if (fieldErr) {
                    return (react_1.default.createElement("span", { className: "glx-form--error-text" }, fieldErr.message));
                }
                return null;
            })())))));
    })));
}
exports.FormRow = FormRow;
